import React from 'react';
import styles from './LoadingOverlay.module.css';

const LoadingOverlay = ({ 
  message = 'Loading...', 
  isVisible = true,
  showSpinner = true,
  transparent = false 
}) => {
  if (!isVisible) return null;

  return (
    <div className={`${styles.overlay} ${transparent ? styles.transparent : ''}`}>
      <div className={styles.content}>
        {showSpinner && (
          <div className={styles.spinner}>
            <div className={styles.spinnerRing}></div>
          </div>
        )}
        <div className={styles.message}>{message}</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;





